import { makeStyles } from 'tss-react/mui';
import { BrandColors } from '../../constants';

export const RaterListStyles = makeStyles()(() => ({
  feedbackStatusContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '2px',
  },
  icons: {
    paddingRight: '4px',
    color: `${BrandColors.grey35} !important`,
  },
}));
